import React from "react";

export interface JupiterAuthInfo {
  apiEndpoint?: string;
  token?: string;
  children?: React.ReactNode;
}

export const JupiterTokenContext = React.createContext<JupiterAuthInfo>({});

export const JupiterHttpProvider: React.FC<JupiterAuthInfo> = ({ apiEndpoint, token, children }) => (
  <JupiterTokenContext.Provider value={{ apiEndpoint, token }}>
    {children}
  </JupiterTokenContext.Provider>
);
